import { useUserMe } from './useUserMe';

export const useIsStaffUser = (): boolean => {
  return useUserMe().data.is_staff ?? false;
};
